import React, { Component } from 'react';
import { observer , inject } from 'mobx-react';



class IframeModal extends Component {

    render() {
        const {iframeURL} = this.props.DGRModalStore
        return(
            <div className='iframeModal'> 
            <iframe className='iframeTag' src={iframeURL}></iframe>

            </div>
        );
    }
}

IframeModal = inject('DGRStore','DGRModalStore')(observer(IframeModal ))     
export default IframeModal ;



// WEBPACK FOOTER //
// ./src/components/DGR/Modal/IFrame.js